module.exports = __webpack_public_path__ + "static/media/story_12.02480105.jpg";